import React from 'react'
import "./navbar.css"
import{AiOutlineHome} from "react-icons/ai"
import{AiOutlineUser} from "react-icons/ai"
import{BiBook} from "react-icons/bi"
import{RiServiceLine} from "react-icons/ri"
import{BiMessageSquareDetail} from "react-icons/bi"
import{useState} from "react"


const Navbar = () => {
  const[activeNav, setActiveNav] = useState("")
  return (
<nav>
  <a href='#inicio' className={activeNav === "#" ? "active" : ""}><AiOutlineHome/></a>
  <a href='#about' onClick={() => setActiveNav("#about" ? "active" : "")}><AiOutlineUser/></a>
  <a href='#experiencia'><BiBook/></a>
  <a href='#servicios'><RiServiceLine/></a>
  <a href='#contacto'><BiMessageSquareDetail/></a>
  
</nav>

    
  )
}

export default Navbar